<main class="p-4 container-lg">
  <div class="row">
    <div class="col-12 col-md-6 offset-md-3">
      <h2>Login</h2>
      <form [formGroup]="form">
        <div class="form-group row mb-3">
          <div class="col">
            <label for="email" class="form-label">Email</label>
            <input type="text" tabindex="1" class="form-control" placeholder="user@email.com" formControlName="email">
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col">
            <label for="password" class="form-label">Password</label>
            <input type="password" tabindex="2" class="form-control" formControlName="password">
          </div>
        </div>

        @if(loginError && !form.touched){
        <div class="alert alert-danger">
          <i class="fa-solid fa-triangle-exclamation"></i> Email or password is incorrect.
        </div>
        }

        <div class="row mt-3">
          <div class="col-12 order-1 order-sm-0 col-sm-6">
            <a routerLink="/register" class="btn btn-link fs-5" tabindex="4">Register</a>
          </div>
          <div class="col-12 order-0 order-sm-1 col-sm-6 text-sm-end">
            <div class="mb-3">
              <button type="submit" tabindex="3" class="btn btn-primary px-5" (click)="login()" [disabled]="loggingIn">
                <i class="fa-solid fa-lock" [class]="{'fa-lock': !loggingIn, 'fa-spinner': loggingIn, 'fa-spin': loggingIn}"></i> Login
              </button>
            </div>
            <div>
              <a routerLink="/forgot-password">Forgot password</a>
            </div>
          </div>

        </div>
      </form>
    </div>
  </div>
</main>
